import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { userUpdateSchema } from "../../ZodSchemas/UserSchemas";
import { countries } from "../../assets/countryLists";
import { userService } from "../../services";
import Spinner from "../../components/UI/Spinner"
import ErrorModal from "../../components/UI/Error"

const UpdateProfile = () => {
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating]= useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(userUpdateSchema),
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user= await userService.myProfile()
        Object.keys(user).forEach((key) => setValue(key, user[key]));
      } catch (error) {
        setError(true)
        console.error("Failed to fetch user data", error);
      } finally{
        setLoading(false)
      }
    };
    fetchUser();
  }, [setValue]);

  const onSubmit = async (data) => {
    setUpdating(true);
   setErrorMessage(null)
    try {
      const updatedUser=await userService.UpdateProfile("me", data)
    } catch (error) {
   setErrorMessage({title:updating, message:"update"})
    } finally {
      setUpdating(false);
    }
  };
  if (loading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>;

  if (error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={`Error ${errorMessage?.title || "Getting"} Your Details`} message={`There is error while trying to ${errorMessage?.message || "fetch"} your details. Please check your internet contivities and refresh this page to try again`} />;
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="">
        <h3 className="text-left text-xl text-gray-900">Update My Profile </h3>
      <div className="border border-gray-200 px-6 py-2 mb-2">
        <h3 className="text-left text-l text-gray-500">Personal </h3>
        <div>
          <input {...register("username")} c/>
          {errors.username && <p className="formErrorText">{errors.username.message}</p>}
        </div>

        <div>
          <input {...register("stageName")} className={`${errors.stageName && "inputError"}`} placeholder="Stage Name" />
          {errors.stageName && <p className="formErrorText">{errors.stageName.message}</p>}
        </div>
        
        <div className="flex gap-2">
          <div className="w-full">
            <input {...register("fullName.fName")} placeholder="First Name" className={`${errors.fullName?.fName && "inputError"}`} />
          {errors.fullName?.fName && <p className="formErrorText">{errors.fullName?.fName?.message}</p>}
          </div>
          <div className="w-full">
            <input {...register("fullName.lName")} placeholder="Last Name" className={`${errors.fullName?.lName && "inputError"}`} />
            {errors.fullName?.lName && <p className="formErrorText">{errors.fullName?.lName?.message}</p>}
          </div>
        </div>
        
        <div className="flex gap-2">
          <div className="w-full">
          <h6 className="text-sm text-gray-400 ml-1 -mb-4 mt-1 p-0 text-left">Date of Birth</h6>
            <input type="date" {...register("dob")} placeholder="Date of Birth" className="" />
          </div>
          <div className="w-full">
          <h6 className="text-sm text-gray-400 ml-1 -mb-4 mt-2 p-0 text-left">Gender</h6>
            <select {...register("gender")} className={`${errors.gender && "inputError"}`}>
              <option value="" >Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            {errors.gender && <p className="formErrorText">{errors.gender.message}</p>}
          </div>
        </div>
        <div>
          <textarea {...register("bio")} className=" resize-none h-[120px]" placeholder="Enter your musical bio" />
          {errors.bio && <p className="text-red-500">{errors.bio.message}</p>}
        </div>
      </div> 

      <div className="border border-gray-200 px-6 py-2 mb-2">
        <h3 className="text-left text-l text-gray-500">Address</h3>
        
        <div>
          <input {...register("address.street")} className="" placeholder="Street Address" />
        </div>

        <div className="flex gap-2">
          <div className="w-full">
            <input {...register("address.city")} className="" placeholder="City" />
          </div>
          <div className="w-full">
            <input {...register("address.state")} className="" placeholder="State" />
          </div>
        </div>

        <div className="flex gap-2">
          <div className="w-full">
            <input {...register("address.postalCode")} className="" placeholder="Postal Code" />
          </div>
          <div className="w-full">
            <select {...register("address.country")} className="">
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="border border-gray-200 px-6 py-2">
        <h3 className="text-left text-l text-gray-500">Social Handles</h3>
        {["facebook", "x", "spotify", "boomplay", "youtube", "instagram", "appleMusic"].map((platform) => (
          <div key={platform} className="">
            <input {...register(`socialHandles.${platform}`)} className="border p-2 w-full" placeholder={platform.charAt(0).toUpperCase() + platform.slice(1)}/>
          </div>
        ))}
      </div>

      <button type="submit" className="formSubmitBtn mb-4" disabled={updating}>
        {updating ? "Updating..." : "Update"}
      </button>
    </form>
  );
};

export default UpdateProfile